import React, { ChangeEvent } from 'react';
import { ConnectionType } from '../../../api/connections.dao';
import { IZoomGroupDTO } from '../../../api/zoom.dao';
import { connectGlobalVM } from '../../global.context';
import { EXTRA_OPTION_ID, RADIX_PARAM, ZERO_OPTION_ID } from '../../../constants/common.constants';

export interface ISelectGroupsOwnProps {
    value: number;
    type?: string;
    onChange: (value: number) => void;
    onBlur?: () => void;
    className?: string;
    selectedGroupRequired?: boolean;
    disabled?: boolean;
    skipDefaultValue?: boolean;
}

export interface ISelectGroupsGlobalProps {
    groups: Readonly<IZoomGroupDTO[]>;
    getDefaultGroupId: () => number;
    getDefaultWebinarGroupId: () => number;
    setGroupIdToCookie: (value: number) => void;
    setWebinarGroupIdToCookie: (value: number) => void;
}

export class SelectGroupsPresentation extends React.Component<ISelectGroupsOwnProps & ISelectGroupsGlobalProps> {
    public constructor(props) {
        super(props);
        if (!props.skipDefaultValue) {
            this.setDefaultGroup();
        }
    }

    public componentDidUpdate(prevProps) {
        if (!prevProps.groups || this.props.value === undefined) {
            this.setDefaultGroup();
        }
    }

    private setDefaultGroup = () => {
        if (this.props.groups) {
            const getDefaultGroupIdFn = this.props.type === ConnectionType.Webinar
                ? this.props.getDefaultWebinarGroupId
                : this.props.getDefaultGroupId;
            const selectedGroupRequiredId = this.props.groups?.[1]?.zoomGroupId || null;
            this.props.onChange(this.props.selectedGroupRequired ? selectedGroupRequiredId : getDefaultGroupIdFn());
        }
    };

    public render() {
        if (!this.props.groups || !this.props.groups.length) {
            return (
                <input
                    type='text'
                    className={this.props.className}
                    value={this.props.value || ''}
                    readOnly={true}
                />
            );
        }

        const groups = this.props.selectedGroupRequired
            ? this.props.groups?.filter(group => (group.zoomGroupId !== EXTRA_OPTION_ID) && (group.zoomGroupId !== ZERO_OPTION_ID as number))
            : this.props?.groups;

        return (
            <select
                className={this.props.className}
                value={this.props.value || ''}
                onChange={this.changeHandler}
                onBlur={this.props.onBlur}
                disabled={this.props.disabled}
            >
                {
                    groups && groups.map((group, key) => {
                       return <option key={key} value={group.zoomGroupId}>{group.name}</option>;
                    })
                }
            </select>
        );
    }

    private changeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
        const newValue = parseInt(event.target.value, RADIX_PARAM);
        this.props.type === ConnectionType.Webinar
            ? this.props.setWebinarGroupIdToCookie(newValue)
            : this.props.setGroupIdToCookie(newValue);
        this.props.onChange(newValue);
    };
}

const SelectGroup = connectGlobalVM<ISelectGroupsGlobalProps, ISelectGroupsOwnProps>(
    SelectGroupsPresentation, vm => {
        return {
            groups: vm.getGroupsVM().getGroupsList(),
            getDefaultGroupId: vm.getGroupsVM().getDefaultGroupId,
            setGroupIdToCookie: vm.getGroupsVM().setGroupIdToCookie,
            getDefaultWebinarGroupId: vm.getGroupsVM().getDefaultWebinarGroupId,
            setWebinarGroupIdToCookie: vm.getGroupsVM().setWebinarGroupIdToCookie
        };
    });

export { SelectGroup };
